import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

type Tier = {
  label: string;
  text: string;
};

const HIGH: Tier = {
  label: "High",
  text: "text-emerald-600 dark:text-emerald-400",
};

const MEDIUM: Tier = {
  label: "Medium",
  text: "text-amber-600 dark:text-amber-400",
};

const LOW: Tier = {
  label: "Low",
  text: "text-rose-600 dark:text-rose-400",
};

const tierFor = (v: number): Tier => {
  if (v >= 0.8) return HIGH;
  if (v >= 0.5) return MEDIUM;
  return LOW;
};

export function ConfidenceMeter({ value }: { value: number | undefined }) {
  if (value == null || Number.isNaN(value)) {
    return <span className="text-muted-foreground/60 text-xs">—</span>;
  }

  const clamped = Math.max(0, Math.min(1, value));
  const tier = tierFor(clamped);
  const pct = clamped * 100;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(
            "cursor-default tabular-nums text-[12px] font-semibold tracking-tight",
            tier.text,
          )}
        >
          {clamped.toFixed(2)}
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="px-2.5 py-1.5">
        <div className="flex items-baseline gap-2">
          <span
            className={cn(
              "text-[11px] font-semibold uppercase tracking-widest",
              tier.text,
            )}
          >
            {tier.label}
          </span>
          <span className="tabular-nums text-xs text-foreground/80">
            {pct.toFixed(1)}%
          </span>
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
